var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.quarterlyPerformance.loading,"empty":_setup.isEmpty}},[_c(_setup.PCOverviewV2,{ref:"overviewV2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }